import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {LoginComponent} from "./login/login.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AuthorizedGuard} from "./guards/authorized-guard";
import {VisbosCoreModule} from "../../core/visbos-core/visbos-core.module";
import {RouterModule} from "@angular/router";
import {HttpClientModule} from "@angular/common/http";

@NgModule({
  imports: [
    CommonModule, HttpClientModule, ReactiveFormsModule, FormsModule, VisbosCoreModule, RouterModule
  ],
  declarations: [LoginComponent],
  providers: [AuthorizedGuard]
})
export class AuthModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.module.ts